<template>

  <section>

    <div class="box">

      <div class="square" style="--i:0;"></div>
      <div class="square" style="--i:1;"></div>
      <div class="square" style="--i:2;"></div>
      <div class="square" style="--i:3;"></div>
      <div class="square" style="--i:4;"></div>
      <div class="square" style="--i:5;"></div>

      <div class="container">
        <div class="form">
          <h2>后台管理</h2>

<!--          <form action="">-->
<!--            <div class="inputBx">-->
<!--              <input type="text" name="account" required="required">-->
<!--              <span>账户</span>-->
<!--              <i class="fas fa-user-circle"></i>-->
<!--            </div>-->
<!--            <div class="inputBx password">-->
<!--              <input id="password-input" type="password" name="password" required="required">-->
<!--              <span>密码</span>-->
<!--              <a href="#" class="password-control" @click="show_hide_password(this)"></a>-->
<!--              <i class="fas fa-key"></i>-->
<!--            </div>-->
<!--            <label class="remember"><input type="checkbox">-->
<!--              记住</label>-->
<!--            <div class="inputBx">-->
<!--              <input id="onlogin" value="登录" disabled>-->
<!--            </div>-->
<!--          </form>-->

          <el-form ref="form" :model="loginData" >
            <div class="inputBx">
              <el-form-item label="账户">
                  <el-input v-model="loginData.account" clearable class="custom-input"></el-input>
              </el-form-item>
            </div>

            <div class="inputBx password">
              <el-form-item label="密码">
                <el-input v-model="loginData.pwd" clearable show-password class="custom-input"></el-input>
              </el-form-item>
            </div>
            <el-form-item>
              <el-button round @click="onLogin" style="width: 200px;background-color: rgba(0, 0, 0, 0);color: white">登录</el-button>
            </el-form-item>
          </el-form>
<!--          <p>Forgot password? <a href="#">Click Here</a></p>-->
<!--          <p>Don't have an account <a href="#">Sign up</a></p>-->
        </div>
      </div>

    </div>
  </section>



</template>

<script>


export default {
  data() {
    return {

      loginData: {
        account: '',
        pwd: '',
      }
    }
  },
  methods: {

    async onLogin() {

      const {data:res} = await this.$ajax.post("/api/admin/login",this.loginData);
      if (res.code === 200 && res.msg === "登录成功" && res.data.token !== ""){
        // this.$msg.success('登录成功');
        window.sessionStorage.setItem('account',this.loginData.account);
        window.sessionStorage.setItem('token',res.data.token);
        window.sessionStorage.setItem('expTime',res.data.expTime);
        window.sessionStorage.setItem('loginTime',new Date().getTime().toString());

        await this.$router.push('/');

      }else this.$msg.error('登录错误:'+res.msg);
    }
  }
}
</script>

<style scoped>

.custom-input /deep/ .el-input__inner {
  background-color: rgba(0, 0, 0, 0);
  border: 0;
  /*height: 30px;*/
}
/deep/ .el-form-item__label {
  color: #ffffff; /* 将label文字颜色设置为绿色 */
}
/*@import url('https://fonts.googleapis.com/css2?family=El+Messiri:wght@700&display=swap');*/
/* arabic */
@font-face {
  font-family: 'El Messiri';
  font-style: normal;
  font-weight: 700;
  font-display: swap;
  src: url(https://fonts.gstatic.com/s/elmessiri/v24/K2FhfZBRmr9vQ1pHEey6GIGo8_pv3myYjuUXfJ5ijDz-oQ.woff2) format('woff2');
  unicode-range: U+0600-06FF, U+0750-077F, U+0870-088E, U+0890-0891, U+0897-08E1, U+08E3-08FF, U+200C-200E, U+2010-2011, U+204F, U+2E41, U+FB50-FDFF, U+FE70-FE74, U+FE76-FEFC, U+102E0-102FB, U+10E60-10E7E, U+10EC2-10EC4, U+10EFC-10EFF, U+1EE00-1EE03, U+1EE05-1EE1F, U+1EE21-1EE22, U+1EE24, U+1EE27, U+1EE29-1EE32, U+1EE34-1EE37, U+1EE39, U+1EE3B, U+1EE42, U+1EE47, U+1EE49, U+1EE4B, U+1EE4D-1EE4F, U+1EE51-1EE52, U+1EE54, U+1EE57, U+1EE59, U+1EE5B, U+1EE5D, U+1EE5F, U+1EE61-1EE62, U+1EE64, U+1EE67-1EE6A, U+1EE6C-1EE72, U+1EE74-1EE77, U+1EE79-1EE7C, U+1EE7E, U+1EE80-1EE89, U+1EE8B-1EE9B, U+1EEA1-1EEA3, U+1EEA5-1EEA9, U+1EEAB-1EEBB, U+1EEF0-1EEF1;
}
/* cyrillic */
@font-face {
  font-family: 'El Messiri';
  font-style: normal;
  font-weight: 700;
  font-display: swap;
  src: url(https://fonts.gstatic.com/s/elmessiri/v24/K2FhfZBRmr9vQ1pHEey6GIGo8_pv3myYjuUXfJ5jjDz-oQ.woff2) format('woff2');
  unicode-range: U+0301, U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116;
}
/* latin-ext */
@font-face {
  font-family: 'El Messiri';
  font-style: normal;
  font-weight: 700;
  font-display: swap;
  src: url(https://fonts.gstatic.com/s/elmessiri/v24/K2FhfZBRmr9vQ1pHEey6GIGo8_pv3myYjuUXfJ5pjDz-oQ.woff2) format('woff2');
  unicode-range: U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF;
}
/* latin */
@font-face {
  font-family: 'El Messiri';
  font-style: normal;
  font-weight: 700;
  font-display: swap;
  src: url(https://fonts.gstatic.com/s/elmessiri/v24/K2FhfZBRmr9vQ1pHEey6GIGo8_pv3myYjuUXfJ5njDw.woff2) format('woff2');
  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
}
* {
  margin: 0;
  padding: 0;
  font-family: 'El Messiri', sans-serif;
}

body {
  background: #031323;
  overflow: hidden;
}

.fas {
  width: 32px;
}

section {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background: linear-gradient(-45deg, #ee7752, #ac8695, #23a6d5, #23d5ab);
  background-size: 400% 400%;
  animation: gradient 10s ease infinite;
}

@keyframes gradient {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

.box {
  position: relative;

.square {
  position: absolute;
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(5px);
  box-shadow: 0 25px 45px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.15);
  border-radius: 15px;
  animation: square 10s linear infinite;
  animation-delay: calc(-1s * var(--i));
}

@keyframes square {
  0%,100% {
    transform: translateY(-20px);
  }

  50% {
    transform: translateY(20px);
  }
}

.square:nth-child(1) {
  width: 100px;
  height: 100px;
  top: -15px;
  right: -45px;
}

.square:nth-child(2) {
  width: 150px;
  height: 150px;
  top: 105px;
  left: -125px;
  z-index: 2;
}

.square:nth-child(3) {
  width: 60px;
  height: 60px;
  bottom: 85px;
  right: -45px;
  z-index: 2;
}

.square:nth-child(4) {
  width: 50px;
  height: 50px;
  bottom: 35px;
  left: -95px;
}

.square:nth-child(5) {
  width: 50px;
  height: 50px;
  top: -15px;
  left: -25px;
}

.square:nth-child(6) {
  width: 85px;
  height: 85px;
  top: 165px;
  right: -155px;
  z-index: 2;
}
}

.container {
  position: relative;
  padding: 50px;
  width: 260px;
  min-height: 380px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(5px);
  border-radius: 10px;
  box-shadow: 0 25px 45px rgba(0, 0, 0, 0.2);
}

.container::after {
  content: '';
  position: absolute;
  top: 5px;
  right: 5px;
  bottom: 5px;
  left: 5px;
  border-radius: 5px;
  pointer-events: none;
  background: linear-gradient( to bottom, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0.1) 2%
  );
}

.form {
  position: relative;
  width: 100%;
  height: 100%;

h2 {
  color: #fff;
  letter-spacing: 2px;
  margin-bottom: 30px;
}

.inputBx {
  position: relative;
  width: 100%;
  margin-bottom: 20px;

.el-input {
  width: 80%;
  outline: none;
  border: none;
  border: 1px solid rgba(255, 255, 255, 0.2);
  background: rgba(255, 255, 255, 0.2);
  padding: 8px 10px;
  padding-left: 40px;
  border-radius: 15px;
  color: #fff;
  font-size: 16px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
}

.password-control {
  position: absolute;
  top: 11px;
  right: 10px;
  display: inline-block;
  width: 20px;
  height: 20px;
  background: url(https://snipp.ru/demo/495/view.svg) 0 0 no-repeat;
  transition: 0.5s;
}

.view {
  background: url(https://snipp.ru/demo/495/no-view.svg) 0 0 no-repeat;
  transition: 0.5s;
}



.fas {
  position: absolute;
  top: 13px;
  left: 13px;
}

input[type="submit"] {
  background: #fff;
  color: #111;
  max-width: 100px;
  padding: 8px 10px;
  box-shadow: none;
  letter-spacing: 1px;
  cursor: pointer;
  transition: 1.5s;
}

input[type="submit"]:hover {
  background: linear-gradient(115deg,
  rgba(0,0,0,0.10),
  rgba(255,255,255,0.25));
  color: #fff;
  transition: .5s;
}

input::placeholder {
  color: #fff;
}

span {
  position: absolute;
  left: 30px;
  padding: 10px;
  display: inline-block;
  color: #fff;
  transition: .5s;
  pointer-events: none;
}

input:focus ~ span,
input:valid ~ span {
  transform: translateX(-30px) translateY(-25px);
  font-size: 12px;
}
}

p {
  color: #fff;
  font-size: 15px;
  margin-top: 5px;

a {
  color: #fff;
}

a:hover {
  background-color: #000;
  background-image: linear-gradient(to right, #434343 0%, black 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
}
}

.remember {
  position: relative;
  display: inline-block;
  color: #fff;
  margin-bottom: 10px;
  cursor: pointer;
}
</style>
